import { READ_LICENSE_TEMPLATE_SUGGEST } from "graphqlQueries/licenseTemplate";
import { readLicenseTemplateSuggestMapper } from "graphqlQueries/licenseTemplate.map";

import useExecuteQuery from "hooks/useExecuteQuery";
import { useMemo } from "react";

export default function useLicenseTemplateSuggests() {
  const { data = [[], []], loading } = useExecuteQuery(
    READ_LICENSE_TEMPLATE_SUGGEST,
    {
      dataMapper: readLicenseTemplateSuggestMapper,
    },
  );

  const [limitsData, featuresData] = data;

  const [limitFields, limitInitialValues] = useMemo(() => {
    const fields = {};
    const initialValues = {};
    limitsData.forEach((limitInfo) => {
      fields[limitInfo.id_limit_type] =
        `${limitInfo.description} (${limitInfo.name})`;
      initialValues[limitInfo.id_limit_type] = limitInfo.value;
    });

    return [fields, initialValues];
  }, [limitsData]);

  const [featureFields, featureInitialValues] = useMemo(() => {
    const fields = {};
    const initialValues = {};
    featuresData.forEach(({ name, features }) => {
      if (!features.length) return;
      fields[name] = {};
      features.forEach((feature) => {
        initialValues[feature.id_feature_type] = feature.value;
        fields[name][feature.id_feature_type] = feature.name;
      });
    });

    return [fields, initialValues];
  }, [featuresData]);

  const initialValues = {
    name: "",
    description: "",
    limits: limitInitialValues,
    features: featureInitialValues,
  };

  return {
    initialValues,
    limitFields,
    featureFields,
    loading,
  };
}
